<template>
  <v-layout column class="pt-4">
    <div :class="{ 'notepad-wrapper': true, dragging: dragging }" @paste="log('paste', $event)">
      <drag-select
        v-if="userCanEdit"
        ref="dragSelect"
        @stopDragSelecting="dragSelecting = false"
      ></drag-select>
      <slot name="header"></slot>
      <note-block
        v-for="(note, index) in documentNotes"
        class="note-block"
        :ref="note.id"
        :key="note.id"
        :note="note"
        :pageId="pageId"
        :docNotes="documentNotes"
        :nestedNotes="nestedNotes"
        :slowLoad="slowLoad"
        :dragSelecting="dragSelecting"
        :selectedNoteBlocks="selectedNoteBlocks"
        :allowQuoteAttr="allowQuoteAttr"
        :dragSelected="selectedNoteBlocks.includes(note.id)"
        :onlyNote="documentNotes.length == 1"
        :lastNote="documentNotes.length == index + 1"
        :index="index"
        :participants="participants"
        @startDragSelect="startDragSelect($event, note.id)"
        @selectMouseEnter="toggleSelection"
        @clearDragSelection="clearDragSelection"
        @addNewLine="addNewLine"
        @moveLineBack="moveLineBack"
        @moveNextLineBack="moveNextLineBack"
        @updateNoteBlockHTML="
          pageId
            ? updateNoteHTML({ ...$event, pageId: pageId })
            : $emit('updateNoteBlockHTML', $event)
        "
        @addNoteBlock="
          pageId
            ? addCardNote({
                ...$event,
                pageId: page.id,
                cardId: false
              })
            : $emit('addNoteBlock', $event)
        "
        @updateSelectedNotes="$emit('updateSelectedNotes', $event)"
        @updateSelectedNotesPage="$emit('updateSelectedNotesPage', $event)"
        @traverseBlocks="traverseBlocks"
        @moveToLine="moveToLine"
        @tabBack="tab"
        @dragStart="setupDrag"
        @copyBlocks="this.$emit('copyBlocks', $event)"
        @removeNoteBlock="removeNoteBlock"
        @removeNotePages="removeNotePages"
        @convertToQuote="$emit('convertToQuote', $event)"
        @convertToCard="convertToCard({ ...$event, noteId: note.id })"
        @convertToNote="convertToNote({ notesLength: $event, noteId: note.id })"
        @popNoteBlock="popNoteBlock({ pageId: pageId, noteId: note.id })"
        @pasteBlocks="pasteNoteBlocks(note.order)"
        @toggleShowSource="
          setShowNoteSource({ pageId: pageId, noteId: note.id, value: !note.showSource })
        "
      ></note-block>
      <!-- <div
        style="height: 50px; width: 100%; cursor: text;"
        @click="addNewLine({ order: documentNotes.length })"
      ></div> -->
      <!-- <v-divider></v-divider> -->
      <slot name="footer"></slot>
    </div>
  </v-layout>
</template>

<script>
import NoteBlock from './NoteBlock';
import DragSelect from './DragSelect.vue';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'ContextDoc',
  components: { NoteBlock, DragSelect },
  props: {
    pageId: {
      type: String
    },
    nested: {
      type: Boolean,
      default: false
    },
    selectedNote: {
      type: Object,
      default() {
        return {};
      }
    },
    allowQuoteAttr: {
      type: Boolean,
      default: false
    },
    parentType: {
      type: String,
      default: 'card'
    },
    docNotes: {
      type: Array,
      default() {
        return [];
      }
    },
    nestedNotes: {
      type: Array,
      default() {
        return [];
      }
    },
    selectedNoteBlocks: {
      type: Array,
      default() {
        return [];
      }
    },
    participants: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      slowLoad: true,
      dragSelecting: false,
      dragSelected: false,
      show: false
    };
  },
  mounted() {
    //  turn off slowload after intial load
    setTimeout(() => (this.slowLoad = false), 3000);
  },
  destroyed() {
    document.removeEventListener('keypress', this.copyTrigger);
  },
  computed: {
    ...mapState('pages', ['pages']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapGetters('context', ['userCanEdit']),
    ...mapState('components/magicClipboard', ['clipboard']),
    page() {
      if (this.pageId) {
        return this.pages[this.pageId];
      } else {
        return false;
      }
    },
    documentNotes() {
      if (this.page) {
        const notes = Object.values(this.page.pageNotes);
        return notes
          .filter(n => !!n & !n.toDelete)
          .sort((a, b) => {
            return a.order < b.order ? -1 : 1;
          });
      } else {
        return this.docNotes;
      }
    },
    // selectedRange() {
    //   try {
    //     const a = this.documentNotes.find(n => n.id == this.selectedNoteBlocks[0]).order;
    //     const b = this.documentNotes.find(
    //       n => n.id == this.selectedNoteBlocks[this.selectedNoteBlocks.length - 1]
    //     ).order;
    //     return a < b ? [a, b] : [b, a];
    //   } catch (e) {
    //     return [-1, -1];
    //   }
    // },
    // selectedNoteRange() {
    //   let range = [-1, -1];
    //   if (this.selectedNoteBlocks.length) {
    //     range = this.selectedNoteBlocks.map(n => this.documentNotes.find(d => d.id == n).order);
    //     range.sort((a, b) => (a < b ? -1 : 1));
    //   }
    //   console.log(range);
    //   return range;
    // }
  },
  watch: {
    pageId: function() {
      //  Reset selectedNoteBlocks
      this.$emit('updateSelectedNotes', { start: false, end: false });
      //  Give us a second to load everything slowly, after that load new things load instanlty
      this.slowLoad = true;
      setTimeout(() => (this.slowLoad = false), 2000);
    },
    selectedNoteBlocks: function(newValue, oldValue) {
      if (!newValue || !newValue.length) {
        this.dragSelected = false;
      }
    }
  },
  methods: {
    ...mapActions('pages', [
      'removeNote',
      'removePage',
      'addCardNote',
      'updateNoteHTML',
      'duplicateNotes',
      'convertNoteToCard',
      'convertCardToNote',
      'popNoteBlock',
      'setShowNoteSource'
    ]),
    //...mapActions('pages', ['removeNoteBlock', 'addNoteBlock']),
    ...mapMutations('views/context', ['setFocusTo']),
    ...mapMutations('components/notepad', ['setClipboard']),
    ...mapMutations('components/dragdrop', ['setDragPosition', 'updateDraggedData']),
    deleteNote(event) {
      if (this.pageId) {
        this.removeNote({ ...event, pageId: this.pageId, cardId: false });
      } else {
        this.$emit('removeNoteBlock', event);
      }
    },
    async convertToCard({ text, noteId, groupSelected }) {
      console.log(' conver to card!!');
      const cardsToGroup = groupSelected ? this.selectedNoteBlocks : [];
      await this.convertNoteToCard({ text, noteId, pageId: this.pageId, cardsToGroup });
      this.$nextTick(() => {
        this.$refs[noteId][0].$refs.embeddedCard.traverseIn({
          event,
          prevLeft: 0,
          direction: 'down'
        });
      });
    },
    async convertToNote({ notesLength, noteId }) {
      console.log('convertToNote', notesLength);
      if (notesLength) {
        //  this page already has notes on it, we should prompt or do nothing
        return;
      } else {
        this.removeNotePages({ noteId, keepNote: true });
        await this.convertCardToNote({ noteId, pageId: this.pageId });
        this.$nextTick(() => {
          this.$refs[noteId][0].focus();
        });
      }
    },
    log(x) {
      console.log(x);
    },
    toggleEmbeddedPages(v) {
      const pageNotes = Object.values(this.page.pageNotes).filter(
        p => !p.toDelete && p.type == 'card'
      );
      pageNotes.forEach(p => {
        this.$refs[p.id][0].setShow(v);
      });
    },
    pasteNoteBlocks(order) {
      console.log('paste');
      console.log(this.clipboard);
      const { type } = this.clipboard;
      if (type == 'block') {
        const { contents, parent } = this.clipboard.blockData;
        this.duplicateNotes({
          noteIds: contents,
          startingPosition: order,
          fromPageId: parent,
          toPageId: this.page.id
        });
      } else if (type == 'clip') {
        const { resourceId, clipId } = this.clipboard.clipData;
        const resourceData = {
          pageId: this.page.id,
          html: false,
          order,
          cardId: false,
          widgetInfo: {
            widgetType: 'resource',
            widgetData: {
              resourceId: resourceId,
              resourceVersion: 1,
              resourceNoteIds: clipId ? [clipId] : []
            }
          }
        };
        this.addCardNote(resourceData);
      }
    },
    // selectBlockHotKeys(event) {
    //   const key = event.which || event.keyCode;
    //   console.log(event);
    //   if (key == 67 && event.ctrlKey) {
    //     this.copyBlocks();
    //   }
    //   if (key == 46 || key == 8) {
    //     //  handle delete
    //     this.deleteSelectedBlocks();
    //   }
    // },
    // copyBlocks() {
    //   console.log('copy blocks context doc');
    //   const blockIds = this.selectedNoteBlocks;
    //   let text = '';
    //   let contents = [];
    //   let blocks = blockIds.map(id => this.docNotes.find(n => n.id == id));

    //   blocks = blocks.sort((a, b) => a.order - b.order);
    //   console.log(blocks);
    //   blocks.forEach(b => {
    //     const content = this.$refs[b.id][0].getText();
    //     text += content;
    //     contents.push(b.content);
    //   });
    //   this.setClipboard({
    //     text,
    //     blockIds,
    //     contents,
    //     parent: this.pageId
    //   });
    //   this.$copyText(text);
    // },
    removeNoteBlock({ noteId }) {
      if (this.pageId) {
        this.removeNote({ noteId, pageId: this.pageId, cardId: false });
      } else {
        this.$emit('removeNoteBlock', { noteId });
      }
    },
    removeNotePages({ noteId, keepNote = false }) {
      const note = this.page.pageNotes[noteId];
      const notesPage = this.pages[note.pageId];
      //  function to recursively delete all children pages
      if (!keepNote) {
        this.removeNote({ noteId, pageId: this.pageId, cardId: false });
      }
      const deleteBranch = page => {
        const embeddedPageNotes = Object.values(page.pageNotes).filter(
          n => !n.toDelete && n.type == 'card'
        );
        if (embeddedPageNotes.length) {
          embeddedPageNotes.forEach(pn => {
            const page = this.pages[pn.pageId];
            deleteBranch(page);
          });
        }
        this.removePage({ pageId: page.id });
      };
      deleteBranch(notesPage);
    },
    // deleteSelectedBlocks() {
    //   const blockIds = this.documentNotes.filter(
    //     n => n.order >= this.selectedNoteRange[0] && n.order <= this.selectedNoteRange[1]
    //   );
    //   blockIds.forEach(b => {
    //     this.$emit('removeNoteBlock', { noteId: b });
    //   });
    // },
    startDragSelect(e, id) {
      this.dragSelecting = true;
      this.dragSelected = true;
      // this.selectedNoteBlocks = [noteId];
      this.$emit('updateSelectedNotes', { start: id });
      this.$emit('updateSelectedNotesPage', this.pageId);
      this.$refs.dragSelect.onMouseDown(e);
    },
    toggleSelection(note) {
      console.log('udpate selected')
      //  just replace the last item with this one.
      // console.log('add note', note.order);
      // const update = [...this.selectedNoteBlocks];
      // update[1] = note.id;
      // console.log(update);

      // this.selectedNoteBlocks
      // //  check if the note we entered is already selected
      // console.log(note.id);
      // const selected = this.selectedNoteBlocks.includes(note.id);
      // const update = [...this.selectedNoteBlocks];
      // if (selected) {
      //   console.log('remove ', note.order);
      //   //  Already selected, we are going back and should deselect the previous one
      //   if (this.selectedNoteBlocks[this.selectedNoteBlocks.length - 1] != note.id) {
      //     update.pop();
      //   }
      // } else {
      //   console.log('add ', note.order);
      //   //  Add this one to selected
      //   update.push(note.id);
      // }
      console.log(note.id);
      this.$emit('updateSelectedNotes', { end: note.id });
    },
    clearDragSelection() {
      this.$emit('updateSelectedNotes', { start: false, end: false });
      this.$emit('updateSelectedNotesPage', null);
    },
    async addNewLine({ order, delta, type, pageType }) {
      console.log(delta);
      if (this.page) {
        const newId = await this.addCardNote({
          html: '',
          order: order,
          pageId: this.page.id,
          cardId: 1,
          type,
          pageType
        });

        this.$nextTick(() => {
          if (delta) {
            this.setNoteContent({ noteId: newId, delta: delta });
          }
          this.focusNoteBlock({ noteId: newId });
        });
      } else {
        this.$emit('addNewLine', { order, delta });
      }
      //  update order of all higher up notes
      //  new vuex note here, returns id

      // const newId = await this.addNoteBlock({
      //   html: '',
      //   order: order,
      //   pageId: this.pageId
      // });

      // this.$nextTick(() => {
      //   if (delta) {
      //     this.setNoteContent({ noteId: newId, delta: delta });
      //   }
      //   this.focusNoteBlock({ noteId: newId });
      // });
    },
    tab() {
      this.$emit('tab');
      //this.setFocusTo('listItem' + this.pageId);
    },
    focusNoteBlock({ noteId }) {
      this.$refs[noteId][0].focus();
    },
    setNoteContent({ noteId, delta }) {
      this.$refs[noteId][0].$refs.editor.editor.setContents(delta);
    },
    moveToLine({ toIndex, direction }) {
      const to = this.documentNotes.find(n => n.order == toIndex);
      if (to) {
        const toRef = this.$refs[to.id][0];
        const index = direction == 'next' ? 0 : toRef.$refs.editor.editor.getLength();
        toRef.$refs.editor.editor.setSelection(index);
      }
    },
    moveLineBack({ note, delta }) {
      console.log(delta);
      const prev = this.documentNotes.find(n => n.order == note.order - 1);
      if (prev) {
        if (this.$refs[prev.id][0].note.type == 'note') {
          const contentEditor = this.$refs[prev.id][0].$refs.editor;
          const editor = contentEditor.editor;
          editor.setSelection(editor.getLength());
          if (delta) {
            contentEditor.updateContents(delta);
          }
        } else if (this.$refs[prev.id][0].note.type == 'widget') {
          this.$refs[prev.id][0].$refs.widget.$el.focus();
          if (delta) {
            //  If there is content on this line, just leave it alone
            return;
          }
        } else {
          this.traverseBlocks({ toIndex: note.order - 1 });
        }
        //  delete note
        this.removeNote({ noteId: note.id, pageId: this.pageId });
        // this.$emit('removeNoteBlock', { noteId: note.id });
      }
    },
    moveNextLineBack({ note }) {
      const next = this.documentNotes.find(n => n.order == note.order + 1);
      if (next) {
        if (this.$refs[next.id][0].note.type == 'note') {
          const nextDelta = this.$refs[next.id][0].$refs.editor.editor.getContents();
          this.$refs[note.id][0].$refs.editor.updateContents(nextDelta);
          //this.$emit('removeNoteBlock', { noteId: next.id });
          this.removeNote({ noteId: next.id, pageId: this.pageId });
        } else if (this.$refs[next.id][0].note.type != 'note') {
          this.traverseBlocks({ toIndex: next.order });
          //this.$refs[next.id][0].$refs.widget.$el.focus();
          if (this.$refs[note.id][0].$refs.editor.editor.getLength() == 1) {
            //this.$emit('removeNoteBlock', { noteId: note.id });
            this.removeNote({ noteId: note.id, pageId: this.pageId });
          }
        }
      }
    },
    traverseBlocks({ toIndex, direction = 'up', event }) {
      console.log('to index', toIndex);
      try {
        let targetRef = false;
        const prevLeft = event && event.bounds ? event.bounds.left : 0;
        if (toIndex == -1) {
          //  go up to whatever is above this document
          this.$emit('traverseLeaveUp', {
            prevLeft,
            direction
          });
          return;
        } else {
          //  get next element in list
          const target = this.documentNotes[toIndex]; //.find(n => n.order == toIndex);
          targetRef = target ? this.$refs[target.id][0] : false;
        }
        if (targetRef) {
          if (toIndex != -1 && targetRef.note.type == 'widget') {
            console.log(targetRef);
            targetRef.$refs.widget.$el.focus();
          } else if (toIndex != -1 && targetRef.note.type == 'card') {
            console.log(targetRef);
            targetRef.$refs.embeddedCard.traverseIn({ event, prevLeft, direction });
          } else {
            //  Put the cursor in the proper position
            //const bound = event && event.bounds ? event.bounds.left : 0;
            targetRef.$refs.editor.setCaret({
              prevLeft,
              direction
            });
          }
        } else {
          // go down to whatever is below this document
          this.$emit('traverseLeaveDown', {
            prevLeft,
            direction: 'down'
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    traverseInto({ event, direction }) {
      console.log('traverse direction', direction);
      if (direction == 'up') {
        this.traverseBlocks({ toIndex: this.documentNotes.length - 1, direction, event });
      } else {
        if (this.documentNotes[0]) {
          this.traverseBlocks({ toIndex: 0, direction, event });
        } else {
          //  no doc notes, create one
          this.$emit('addNewLine', { order: 0 });
        }
      }
    },
    setupDrag({ event, ids, element, shift }) {
      // get the element and shift positions for dragHelper
      let html = '';
      //  Build the html drag element
      let allIds = ids;

      if (this.selectedNoteBlocks && this.selectedNoteBlocks.includes(ids[0])) {
        //  Drag all the selected note blocks
        allIds = this.selectedNoteBlocks;
      }
      const items = [];
      allIds.forEach(i => {
        html += this.$refs[i][0].$el.innerHTML;
        items.push(this.documentNotes.find(n => n.id == i));
      });

      // update drag data
      const dragObject = {
        element,
        shift,
        html,
        ids: allIds,
        items,
        types: ['noteBlock'],
        parent: {
          id: this.pageId,
          type: this.parentType
        }
      };
      // console.log(dragObject);
      //  first set initial drag position
      const { x, y } = event;
      this.setDragPosition({ x, y });

      //  now set drag content
      this.updateDraggedData(dragObject);
    }
  }
};
</script>

<style>
.prompt-btn,
.prompt-btn .v-btn__content {
  justify-content: left !important;
}

@media (min-width: 1264px) {
  .notepad-sizer {
    max-width: 600px !important;
    width: 600px !important;
  }
}

@media (min-width: 1904px) {
  .notepad-sizer {
    max-width: 700px !important;
    width: 700px !important;
  }
}
</style>
